---
title: Chat with an expert
summary: Ask questions, watch answers stream in, and check the sources behind each reply.
visibility: public
audience: end-user
section: Using an expert
order: 110
last_verified: 2026-06-19
owner: docs
---

# Chat with an expert

An AI expert answers your questions using a knowledge base, and shows you the sources it
used. Here's how a text conversation works.

## Ask a question

Type your message in the box at the bottom and press **Enter** to send (use **Shift+Enter**
for a new line). The reply streams in word by word. If you want to stop a reply while it's
still being written, click the **Stop** button that replaces Send during streaming.

If you're not sure what to ask, a new conversation suggests a few starter questions — click
one to drop it into the box.

## Read the sources

When the expert draws on its knowledge base, a **Sources** panel shows the passages it used,
each with a relevance score. Click a source to open it and read the full passage — for a
document you'll see the relevant page, and for audio or video it jumps to the right moment.
Inside the viewer you can move **Previous/Next** between sources, **Copy** the text, or
**Open Original**.

Citations let you verify an answer rather than taking it on faith. If an answer has no
sources, the expert is drawing on general knowledge rather than your documents.

## Next

- Prefer to talk? [Use voice instead](/help/enduser/voice-conversations).
- Find past chats and give feedback: [View your conversations](/help/enduser/conversations-and-feedback).
